import React, { useState, useEffect } from "react";
import styles from "./profile.module.scss";
import { FaEnvelope, FaPhoneAlt } from "react-icons/fa";
import { MdOutlineNavigateNext } from "react-icons/md";
import { CiEdit } from "react-icons/ci";
import GoogleMapComponent from "../../../../components/GoogleMap/GoogleMap";
import { useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { openMaps } from "../../../../store/Partner/modalSlice";
import bannerImg from "../../../../assets/images/DashboardImages/profileBack.png";
import logoImg from "../../../../assets/images/logo/onlylogo.png";
import mapImg from "../../../../assets/images/DashboardImages/mapimage.png";
import mapNavImg from "../../../../assets/images/DashboardImages/mapnav.png";
import BreadCrumb from "../../../../components/BreadCrumb/BreadCrumb";
import Avatar from "../../../../components/Avatar/Avatar";


const Profile = () => {
  const navigate = useNavigate();
  const userDetails = useSelector((state) => state.partner.user);
  const profileImg = userDetails?.profile_img || "default-avatar.png";
  const dispatch = useDispatch();
  const showGoogleMap = useSelector((state) => state.modal.showGoogleMap);
  const defaultLanguages = ["English"];

  const [userLocation, setUserLocation] = useState({
    lat: userDetails?.partner?.location?.location_lat || 28.6139,
    lng: userDetails?.partner?.location?.location_long || 77.209,
  });

  useEffect(() => {
    if (navigator.geolocation) {
      navigator.geolocation.getCurrentPosition(
        (position) => {
          setUserLocation({
            lat: position.coords.latitude,
            lng: position.coords.longitude,
          });
        },
        () => {
          console.warn("User denied location access. Using default location.");
        }
      );
    }
  }, []);

  const mapUrl = `https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d1000!2d${userLocation.lng}!3d${userLocation.lat}!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x0%3A0x0!2z!5e0!3m2!1sen!2sin!4v1731170938242!5m2!1sen!2sin`;
  console.log(userDetails.name)
  return (
    <>
    <div>
      <BreadCrumb paths={[{name:"Home",path:'/dashboard'},{name:"Profile",path:"/dashboard/partner"}]}/>
    </div>
    <div className={styles.profileContainer}>
      <div className={styles.banner}>
        <img src={bannerImg} alt="Banner" className={styles.bannerImage} />
        {
        // !profileImg=="default-avatar.png"?
        userDetails?.profile_img?
        <img src={userDetails?.profile_img} alt="Profile" className={styles.avatar} />

        : <div className={styles.avatar}><Avatar
        fontSize={"24px"}
        name={userDetails ? userDetails.name : "Fetching..."}
      />
      </div>}
        <img src={logoImg} alt="Logo" className={styles.logo} />
      </div>
      <div className={styles.detailsContainer}>
        <div className={styles.userInfo}>
          <h2 className={styles.userName}>
            {userDetails?.name || "No username provided"}
          </h2>
          <CiEdit
            className={styles.editIcon}
            onClick={() => navigate("/dashboard/partner/edit-profile")}
          />
        </div>
        <p className={styles.location}>
          {userDetails?.partner?.location
            ? `${userDetails.partner.location.local_area || "Unknown"}, ${
                userDetails.partner.location.locality || "Unknown"
              }`
            : "No Location Provided!"}
        </p>

        <div className={styles.contactDetails}>
          <p className={styles.email}>
            <FaEnvelope className={styles.icon} />{" "}
            {userDetails?.email || "No email provided"}
          </p>
          <p className={styles.phone}>
            <FaPhoneAlt className={styles.icon} />{" "}
            {userDetails?.partner?.contact_number ||
              "No mobile number provided"}
          </p>
        </div>

        <p className={styles.description}>
          {userDetails?.partner?.description || "No description provided"}
        </p>
        <hr className={styles.divider} />
      </div>
      <div className={styles.section}>
        <h3 className={styles.sectionTitle}>Language</h3>
        <div className={styles.languageContainer}>
          {userDetails?.languages?.length
            ? userDetails.languages.map((lang, index) => (
                <span key={index} className={styles.languageTag}>
                  {lang.name}
                </span>
              ))
            : defaultLanguages.map((lang, index) => (
                <span key={index} className={styles.languageTag}>
                  {lang}
                </span>
              ))}
        </div>
      </div>
      <div className={styles.section}>
        <h3 className={styles.sectionTitle}>Address</h3>
        <div className={styles.mapWrapper}>
          <img src={mapImg} alt="Map" className={styles.mapImage} />
          <img
            src={mapNavImg}
            alt="Navigate"
            className={styles.mapNavIcon}
            onClick={() => {
              const currentLat =
                userDetails?.partner?.location?.location_lat ||
                userLocation.lat;
              const currentLng =
                userDetails?.partner?.location?.location_long ||
                userLocation.lng;

              const newMapUrl = `https://www.google.com/maps?q=${currentLat},${currentLng}&hl=es;z=14&output=embed`;
              console.log("Opening Map with Current Location:", newMapUrl);
              window.open(newMapUrl, "_blank");
            }}
          />
        </div>
        <p className={styles.address}>
          {userDetails?.partner?.location
            ? `${userDetails.partner.location.local_area || "Unknown"}, ${
                userDetails.partner.location.locality || "Unknown"
              }`
            : "Please Add Location!"}
        </p>

        <button
          className={styles.addLocationBtn}
          onClick={() => {
            dispatch(openMaps());
            console.log("Dispatching openMaps() action...");
          }}
        >
          Add Location
        </button>
        {showGoogleMap && <GoogleMapComponent />}
      </div>
      <div className={styles.section}>
        <h3 className={styles.sectionTitle}>Skills</h3>
        <div className={styles.languageContainer}>
          {userDetails?.partner?.skills?.length ? (
            userDetails.partner.skills.map((skill, index) => (
              <span key={index} className={styles.languageTag}>
                {skill.skill_name}
              </span>
            ))
          ) : (
            <p className={styles.noData}>No skills provided</p>
          )}
        </div>
      </div>

      <div className={styles.section}>
        <h3 className={styles.sectionTitle}>Roles</h3>
        <div className={styles.languageContainer}>
          {userDetails?.partner?.roles?.length ? (
            userDetails.partner.roles.map((role, index) => (
              <span key={index} className={styles.languageTag}>
                {role.role_name}
              </span>
            ))
          ) : (
            <p className={styles.noData}>No roles selected yet</p>
          )}
        </div>
      </div>

      <hr className={styles.divider} />
      <div className={styles.navLinks}>
        <ul className={styles.navList}>
          <li
            onClick={() => navigate("/dashboard/equipments")}
            className={styles.navItem}
          >
            Equipments
            <MdOutlineNavigateNext className={styles.navIcon} />
          </li>
          <li
            onClick={() => navigate("/dashboard/licenses")}
            className={styles.navItem}
          >
            License
            <MdOutlineNavigateNext className={styles.navIcon} />
          </li>
          <li
            onClick={() => navigate("/dashboard/certificates")}
            className={styles.navItem}
          >
            Certificates
            <MdOutlineNavigateNext className={styles.navIcon} />
          </li>
          <li
            onClick={() => navigate("/dashboard/social")}
            className={styles.navItem}
          >
            Social Profile Links
            <MdOutlineNavigateNext className={styles.navIcon} />
          </li>
          <li
            onClick={() => navigate("/dashboard/kycdocuments")}
            className={styles.navItem}
          >
            KYC
            <MdOutlineNavigateNext className={styles.navIcon} />
          </li>
          <li
            onClick={() => navigate("/dashboard/services")}
            className={styles.navItem}
          >
            Services
            <MdOutlineNavigateNext className={styles.navIcon} />
          </li>
        </ul>
      </div>
    </div>
    </>
  );
};

export default Profile;
